blue.ready('body_outline', 'body', body => {
	body.addEventListener('mousedown', function() {
		body.classList.add('is-usingMouse');
		body.classList.remove('is-usingKeyboard');
	});
	body.addEventListener('keydown', function() {
		body.classList.add('is-usingKeyboard');
		body.classList.remove('is-usingMouse');
	});
});